// These should be overridden by the implementation
const errorHandler = {
	getHTTPErrorHandler: (_error?: Error) => null
};

export default errorHandler;
